import { Component, EventEmitter, OnDestroy, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EditDurationsService } from "../services/edit-durations.service";
import { TimerService } from "../services/timer.service";
import { finalize, takeUntil } from "rxjs/operators";
import { JiraService } from "../services/jira.service";

@Component({
    selector: "nx-edit-timer-single-duration-dialog",
    templateUrl: "./edit-timer-single-duration-dialog.component.html",
    styleUrls: ["./edit-timer-single-duration-dialog.component.scss"],
    standalone: false
})
export class EditTimerSingleDurationDialogComponent implements OnInit, OnDestroy {
  data = inject(MAT_DIALOG_DATA);
  timerService = inject(TimerService);
  dialogRef = inject<MatDialogRef<EditTimerSingleDurationDialogComponent>>(MatDialogRef);
  editDurationsService = inject(EditDurationsService);
  jiraService = inject(JiraService);

  public durationsFormValid: boolean;
  public position: number;
  private _destroyEmitter = new EventEmitter<void>();

  public isDurationFormValid(event): void {
    this.durationsFormValid = event;
  }

  ngOnInit(): void {
    this.position = this.data["position"];
  }

  public saveChanges(): void {
    this.jiraService.isLoading$.next(true);
    this.editDurationsService.saveChanges()
      .pipe(
        takeUntil(this._destroyEmitter),
        finalize(() => {
          this.dialogRef.close();
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.jiraService.isLoading$.next(false);
    this._destroyEmitter.next();
  }
}
